/* belt-size: pick-a-size gate. Spec docs/superpowers/specs/2026-09-28-belt-size-picker.md */
(function () {
  'use strict';

  if (window.beltSizeGateInit) return;
  window.beltSizeGateInit = true;

  var FIELDSET_SEL = '[data-belt-size-required]';
  var FORM_ATTR = 'data-belt-size-form';
  var PICKED_CLASS = 'belt-size--picked';
  var ERROR_CLASS = 'belt-size--error';
  var PENDING_CLASS = 'belt-size-atc-pending';
  var ORIG_DISABLED = 'data-belt-size-orig-disabled';
  var ORIG_ARIA = 'data-belt-size-orig-aria';
  var ORIG_ARIA_DISABLED = 'data-belt-size-orig-aria-disabled';

  var TEXT_PLACEHOLDER = 'Select your size';
  var TEXT_SIZE_LINE = 'Not selected';
  var TEXT_BUTTON = 'Select a size';

  // Form ids where the shopper picked a size. Empty on every page load (spec decision 2).
  var picked = new Set();
  // Value to show right after a label click, until the theme re-render brings the new data-selected.
  var displayOverride = {};
  // Form ids picked with a NEW value: the button stays pending until that form's product:rerender arrives.
  var awaitingRerender = {};
  var AWAIT_FALLBACK_MS = 8000;
  // Belt fieldset nodes already known, to spot a fresh quick-buy drawer load (replaceChildren with new markup).
  var seenFieldsets = new WeakSet();

  var OWNER_SEL = FIELDSET_SEL + ',[data-belt-size-popover]';

  // Form id for an element inside a belt fieldset, or inside the belt popover (moved to <body> at <=999px).
  function ownerFormId(el) {
    var owner = el && el.closest ? el.closest(OWNER_SEL) : null;
    if (!owner) return null;
    return owner.getAttribute(FORM_ATTR) || owner.getAttribute('data-belt-size-popover') || null;
  }

  function togglePopovers(root, formId, isPicked) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-belt-size-popover]'), function (pop) {
      var id = pop.getAttribute('data-belt-size-popover');
      if (formId != null && id !== formId) return;
      var on = formId != null ? isPicked : picked.has(id);
      if (pop.classList.contains(PICKED_CLASS) !== on) pop.classList.toggle(PICKED_CLASS, on);
    });
  }

  function formIdOf(form) {
    // form.id is the variant "id" input on product forms, so read the attribute.
    return form && form.getAttribute ? form.getAttribute('id') : null;
  }

  function beltFieldsets(root, formId) {
    var list = Array.prototype.slice.call(root.querySelectorAll(FIELDSET_SEL));
    if (formId == null) return list;
    return list.filter(function (fs) { return fs.getAttribute(FORM_ATTR) === formId; });
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function submitButtonsFor(formId) {
    var out = [];
    var form = document.forms[formId];
    if (form && form.elements) {
      Array.prototype.forEach.call(form.elements, function (el) {
        if (el.tagName === 'BUTTON' && el.type === 'submit') out.push(el);
      });
    }
    Array.prototype.forEach.call(document.querySelectorAll('button[type="submit"][form]'), function (el) {
      if (el.getAttribute('form') === formId && out.indexOf(el) === -1) out.push(el);
    });
    return out;
  }

  // The button's child nodes are never touched (Candy Rack and the theme's custom-button rewrite them).
  // Pending = class (CSS draws "Select a size") + aria-label; the saved attributes mark a button we changed.
  function setPending(btn) {
    if (btn.classList.contains(PENDING_CLASS) && btn.hasAttribute(ORIG_DISABLED)) {
      if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
      if (btn.getAttribute('aria-label') !== TEXT_BUTTON) btn.setAttribute('aria-label', TEXT_BUTTON);
      return;
    }
    btn.setAttribute(ORIG_DISABLED, btn.hasAttribute('disabled') ? '1' : '0');
    if (btn.hasAttribute('aria-label')) btn.setAttribute(ORIG_ARIA, btn.getAttribute('aria-label'));
    if (btn.hasAttribute('aria-disabled')) btn.setAttribute(ORIG_ARIA_DISABLED, btn.getAttribute('aria-disabled'));

    btn.setAttribute('aria-label', TEXT_BUTTON);
    btn.removeAttribute('disabled');
    btn.removeAttribute('aria-disabled');
    btn.classList.add(PENDING_CLASS);
  }

  function restoreButton(btn) {
    if (!btn.hasAttribute(ORIG_DISABLED)) {
      // Theme re-rendered the button: nothing of ours to restore.
      if (btn.classList.contains(PENDING_CLASS)) btn.classList.remove(PENDING_CLASS);
      return;
    }
    if (btn.getAttribute(ORIG_DISABLED) === '1') btn.setAttribute('disabled', '');
    else btn.removeAttribute('disabled');

    if (btn.hasAttribute(ORIG_ARIA)) btn.setAttribute('aria-label', btn.getAttribute(ORIG_ARIA));
    else btn.removeAttribute('aria-label');

    if (btn.hasAttribute(ORIG_ARIA_DISABLED)) btn.setAttribute('aria-disabled', btn.getAttribute(ORIG_ARIA_DISABLED));

    btn.removeAttribute(ORIG_DISABLED);
    btn.removeAttribute(ORIG_ARIA);
    btn.removeAttribute(ORIG_ARIA_DISABLED);
    btn.classList.remove(PENDING_CLASS);
  }

  function displayTexts(fs, isPicked, formId) {
    var placeholder = fs.querySelector('[data-belt-size-placeholder]');
    var sizeLine = fs.querySelector('[data-belt-size-value]');
    var override = isPicked && formId != null ? displayOverride[formId] : null;
    if (placeholder) {
      setText(placeholder, isPicked ? (override || placeholder.getAttribute('data-selected') || '') : TEXT_PLACEHOLDER);
    }
    if (sizeLine) {
      setText(sizeLine, isPicked ? (override || sizeLine.getAttribute('data-selected') || '') : TEXT_SIZE_LINE);
    }
  }

  function apply() {
    var seen = {};
    var fieldsets = beltFieldsets(document);
    // A belt fieldset we have never seen inside a quick-buy drawer means the drawer loaded fresh markup:
    // that form starts unpicked again (the drawer can reuse a form id between opens).
    fieldsets.forEach(function (fs) {
      if (seenFieldsets.has(fs)) return;
      seenFieldsets.add(fs);
      var formId = fs.getAttribute(FORM_ATTR);
      if (formId && fs.closest('quick-buy-drawer')) forgetPick(formId);
    });
    togglePopovers(document, null);
    fieldsets.forEach(function (fs) {
      var formId = fs.getAttribute(FORM_ATTR);
      if (!formId) return;
      var isPicked = picked.has(formId);
      var buttonsPending = !isPicked || !!awaitingRerender[formId];

      if (isPicked) {
        if (!fs.classList.contains(PICKED_CLASS)) fs.classList.add(PICKED_CLASS);
        hideError(fs);
      } else if (fs.classList.contains(PICKED_CLASS)) {
        fs.classList.remove(PICKED_CLASS);
      }
      displayTexts(fs, isPicked, formId);

      if (seen[formId]) return;
      seen[formId] = true;
      submitButtonsFor(formId).forEach(function (btn) {
        if (!buttonsPending) {
          if (btn.classList.contains(PENDING_CLASS) || btn.hasAttribute(ORIG_DISABLED)) restoreButton(btn);
        } else {
          setPending(btn);
        }
      });
    });
  }

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      apply();
    });
  }

  function hideError(fs) {
    if (fs.classList.contains(ERROR_CLASS)) fs.classList.remove(ERROR_CLASS);
    var err = fs.querySelector('[data-belt-size-error]');
    if (err && !err.hidden) err.hidden = true;
  }

  function isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  function inViewport(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    return r.top >= 0 && r.bottom <= h;
  }

  function showError(formId) {
    var fieldsets = beltFieldsets(document, formId);
    if (!fieldsets.length) return;
    var target = null;
    fieldsets.forEach(function (fs) {
      fs.classList.add(ERROR_CLASS);
      var err = fs.querySelector('[data-belt-size-error]');
      if (err) err.hidden = false;
      if (!target && isVisible(fs)) target = fs;
    });
    if (!target) return;

    if (!inViewport(target)) {
      try {
        target.scrollIntoView({ block: 'center', behavior: 'instant' });
      } catch (e) {
        target.scrollIntoView(true);
      }
    }

    var toggle = target.querySelector('[data-belt-size-toggle]');
    if (toggle) {
      setTimeout(function () {
        if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
      }, 0);
    } else {
      var first = target.querySelector('input[type="radio"]:not([disabled])') || target.querySelector('label');
      if (first) {
        try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
      }
    }
  }

  function needsPick(form) {
    var formId = formIdOf(form);
    if (!formId || picked.has(formId)) return null;
    return beltFieldsets(document, formId).length ? formId : null;
  }

  function forgetPick(formId) {
    picked.delete(formId);
    delete displayOverride[formId];
    if (awaitingRerender[formId]) {
      clearTimeout(awaitingRerender[formId]);
      delete awaitingRerender[formId];
    }
  }

  function stopAwaiting(formId) {
    if (!awaitingRerender[formId]) return;
    clearTimeout(awaitingRerender[formId]);
    delete awaitingRerender[formId];
  }

  // changed = the pick selects a different value, so a re-render is on its way: keep the button pending until then.
  function markPicked(formId, label, changed) {
    if (!formId) return;
    picked.add(formId);
    var text = label ? label.textContent.trim() : '';
    if (text) displayOverride[formId] = text;
    if (changed && !awaitingRerender[formId]) {
      // Fallback so a failed re-render fetch cannot leave the button stuck on "Select a size".
      awaitingRerender[formId] = setTimeout(function () {
        delete awaitingRerender[formId];
        apply();
      }, AWAIT_FALLBACK_MS);
    }
    apply();
  }

  function labelFor(input) {
    if (input.labels && input.labels.length) return input.labels[0];
    return input.closest('label');
  }

  function hidePopover(el) {
    var popover = el.closest('x-popover');
    if (popover && typeof popover.hide === 'function') popover.hide();
  }

  // Pick detection. A label click also covers the already-checked value, which fires no change event.
  // No stopPropagation: the theme popover still closes on a changed select.
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    if (t.matches && t.matches('input[type="radio"]')) {
      // Direct radio click (Space on a radio in block style). Checkedness is already updated here, so a
      // real change is detected by the change listener below, in the same task, before any paint.
      var radioForm = ownerFormId(t);
      if (radioForm) markPicked(radioForm, labelFor(t), false);
      return;
    }
    var label = t.closest('label');
    if (!label) return;
    var formId = ownerFormId(label);
    if (!formId) return;
    var input = label.control;
    var sameValue = !!(input && input.checked);
    markPicked(formId, label, !sameValue);
    if (sameValue) hidePopover(label);
  }, true);

  // A value change (mouse or keyboard) always means a re-render is coming.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.closest || input.type !== 'radio') return;
    var formId = ownerFormId(input);
    if (formId) markPicked(formId, labelFor(input), true);
  }, true);

  // Patch the incoming section fragment before the theme swaps it in (avoids a flash).
  function eachRoot(root, fn) {
    fn(root);
    Array.prototype.forEach.call(root.querySelectorAll('template'), function (tpl) {
      eachRoot(tpl.content, fn);
    });
  }

  document.addEventListener('product:rerender', function (event) {
    var formId = formIdOf(event.target);
    var fragment = event.detail && event.detail.htmlFragment;
    if (!formId || !fragment || !fragment.querySelectorAll) return;
    delete displayOverride[formId];
    stopAwaiting(formId);
    var isPicked = picked.has(formId);

    eachRoot(fragment, function (root) {
      // Re-rendered fieldsets are not a fresh drawer load.
      beltFieldsets(root).forEach(function (fs) { seenFieldsets.add(fs); });
      togglePopovers(root, formId, isPicked);
      var fieldsets = beltFieldsets(root, formId);
      if (!fieldsets.length) return;
      fieldsets.forEach(function (fs) {
        if (isPicked) fs.classList.add(PICKED_CLASS);
        displayTexts(fs, isPicked, null);
      });
      if (isPicked) return;
      Array.prototype.forEach.call(root.querySelectorAll('button[type="submit"]'), function (btn) {
        var ownForm = btn.getAttribute('form');
        var closestForm = btn.closest('form');
        if (ownForm === formId || (!ownForm && closestForm && closestForm.getAttribute('id') === formId)) {
          setPending(btn);
        }
      });
    });
    // Buttons outside the swapped section (e.g. sticky bar) are restored by the observer's apply().
    scheduleApply();
  }, true);

  // Re-renders and dynamically inserted drawers: re-apply on DOM changes.
  function startObserver() {
    new MutationObserver(scheduleApply).observe(document.body, { childList: true, subtree: true });
  }

  // Gate: capture on window so it runs before theme and app handlers. Only acts while blocking.
  function block(event, formId) {
    event.preventDefault();
    event.stopImmediatePropagation();
    showError(formId);
  }

  // Picked a new size but the theme has not re-rendered yet: the form still holds the old variant.
  // Swallow silently (no error, no list); the button still reads "Select a size" for that moment.
  function awaiting(form) {
    var formId = formIdOf(form);
    return !!(formId && awaitingRerender[formId]);
  }

  function gate(event, form) {
    var formId = needsPick(form);
    if (formId) {
      block(event, formId);
    } else if (awaiting(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  window.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var btn = t.closest('button[type="submit"]');
    if (!btn || !btn.form) return;
    gate(event, btn.form);
  }, true);

  window.addEventListener('submit', function (event) {
    gate(event, event.target);
  }, true);

  function init() {
    apply();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
